import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { CampaignContext } from "../../../../../contexts/CampaignContext";
import Collaborators from "./OverviewHeaderParts/Collaborators";
import Platforms from "./OverviewHeaderParts/Platforms";
import UF from "../../../../FormComponents/UpdatableField";
import { toastSuccess } from "../../../../FormComponents/Toasts";
import { useNavigate, useParams } from "react-router-dom";
import { PencilSquare, PersonPlusFill } from "react-bootstrap-icons";
import CollaboratorModal from "./OverviewHeaderParts/CollaboratorParts/CollaboratorModal";
import { useReadOnly } from "../../../../../contexts/ReadOnlyContext";

export default observer(function OverviewHeader() {
  const { campaign } = useContext(CampaignContext);
  const readOnly = useReadOnly();
  const { id } = useParams();
  const navigate = useNavigate();
  const [collaboratorModalOpen, setCollaboratorModalOpen] = useState(false);
  const campaignUpdatePath = `/api/project_manager/campaigns/${id}`;

  return (
    <div className="bg-rb-grey dark:bg-rb-dark-mode p-8">
      <div className="flex justify-between items-start gap-6">
        <div className="flex-1 min-w-0">
          <div className="py-1 flex items-center gap-2">
            <div>
              <UF
                url={campaignUpdatePath}
                model="campaign"
                attribute="name"
                className="text-2xl font-bold mt-0 h-9 dark:text-white"
                onFieldUpdate={(camp) => {
                  campaign.name = camp.name;
                  toastSuccess("Campaign name has been updated");
                }}
              >
                {campaign.name}
              </UF>
            </div>
            <Collaborators />
            {!readOnly && (
              <button
                type="button"
                className="w-9 h-9 bg-white text-rb-green rounded-full flex items-center justify-center border-1 border-border-primary dark:border-rb-dark-mode-lighter dark:bg-rb-dark-mode"
                onClick={() => setCollaboratorModalOpen(true)}
                title="Add collaborators"
                aria-label="Add collaborators"
              >
                <PersonPlusFill className="w-4 h-4" />
              </button>
            )}
          </div>
          <div className="flex mt-2">
            <div className="flex py-1 pr-3 border-r-1 border-light-grey dark:border-rb-dark-mode-lighter">
              <span className="text-sm mr-2 text-rb-lighter-grey dark:text-gray-400">
                Client
              </span>
              <span className="text-sm text-rb-mat-grey dark:text-white text-bold">
                <UF
                  url={`/api/project_manager/clients/${campaign.client_id}`}
                  model="client"
                  attribute="name"
                  className="text-sm text-rb-mat-grey dark:text-white text-bold h-5"
                  onFieldUpdate={(client) => {
                    campaign.client_name = client.name;
                    toastSuccess("Client name has been updated");
                  }}
                >
                  {campaign.client_name || "ClientName"}
                </UF>
              </span>
            </div>
            <div className="flex py-1 pr-3">
              <span className="text-sm mx-2 text-rb-lighter-grey dark:text-gray-400">
                Id
              </span>
              <span className="text-sm text-rb-mat-grey dark:text-white">
                <UF
                  url={campaignUpdatePath}
                  model="campaign"
                  attribute="project_number"
                  className="text-sm text-rb-mat-grey dark:text-white text-bold h-5"
                  onFieldUpdate={(camp) => {
                    campaign.project_number = camp.project_number;
                    toastSuccess("Project ID has been updated");
                  }}
                >
                  {campaign.project_number}
                </UF>
              </span>
            </div>
          </div>
          <div className="mt-2 flex items-center">
            <Platforms />
          </div>
          <CollaboratorModal
            collaboratorModalOpen={collaboratorModalOpen}
            setCollaboratorModalOpen={setCollaboratorModalOpen}
            hasSideBar
          />
        </div>
        <div className="flex flex-col items-end gap-2 flex-shrink-0">
          {!readOnly && (
            <button
              type="button"
              onClick={() => navigate(`/project_manager/campaigns/${id}/edit`)}
              className="flex flex-shrink-0 items-center gap-2 text-sm font-semibold border-1 border-border-primary dark:border-rb-dark-mode-lighter text-gray-800 dark:text-white px-4 py-2 rounded-lg bg-white dark:bg-rb-dark-mode hover:bg-gray-100 dark:hover:bg-rb-dark-mode-lighter"
            >
              <PencilSquare className="text-rb-green dark:text-rb-green" aria-hidden />
              Edit campaign
            </button>
          )}
          <div className="bg-white dark:bg-rb-dark-mode border-1 border-rb-lite-grey dark:border-rb-dark-mode-lighter rounded-md flex items-center">
            <img
              src={campaign.owner_avatar}
              alt="Owner Avatar"
              className="w-8 h-8 rounded-full mx-2 object-cover"
            />
            <div className="flex flex-col items-start justify-center px-3 border-r-1 border-rb-lite-grey dark:border-rb-dark-mode-lighter">
              <p className="text-sm text-rb-lighter-grey dark:text-gray-400">
                Owner
              </p>
              <p className="text-sm font-bold dark:text-white">
                {campaign.owner_name}
              </p>
            </div>
            <div className="flex flex-col items-start justify-center px-3">
              <p className="text-sm text-rb-lighter-grey dark:text-gray-400">
                Created
              </p>
              <p className="text-sm font-bold dark:text-white">
                {campaign?.created_at?.split("T")[0]}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
